import { statisticsWindow, type StatisticsPeriod } from './statistics'
import type { DouyinLiveAnalysisMeta } from './douyinTypes'

export type DouyinStatisticsPeriod = StatisticsPeriod | 'all'

export interface DouyinStatisticsWindow {
  key: DouyinStatisticsPeriod
  label: string
  startDate: string
  endDate: string
  dataStartDate: string
  dataEndDate: string
}

export function douyinStatisticsWindow(
  meta: Pick<DouyinLiveAnalysisMeta, 'queryStart' | 'queryEnd'> | null | undefined,
  period: DouyinStatisticsPeriod,
): DouyinStatisticsWindow | null {
  if (!meta) return null
  if (period === 'all') return {
    key: 'all',
    label: '全部',
    startDate: meta.queryStart,
    endDate: meta.queryEnd,
    dataStartDate: meta.queryStart,
    dataEndDate: meta.queryEnd,
  }
  const window = statisticsWindow(period, meta.queryEnd, [])
  return {
    key: period,
    label: window.label,
    startDate: window.startDate,
    endDate: window.endDate,
    dataStartDate: meta.queryStart,
    dataEndDate: meta.queryEnd,
  }
}

export function douyinStatisticsSearch(period: DouyinStatisticsPeriod) {
  return `?${new URLSearchParams({ period }).toString()}`
}
